import { render, staticRenderFns } from "./Audiotrack.vue?vue&type=template&id=671084f1&scoped=true&"
import script from "./Audiotrack.vue?vue&type=script&lang=js&"
export * from "./Audiotrack.vue?vue&type=script&lang=js&"
import style0 from "./Audiotrack.vue?vue&type=style&index=0&id=671084f1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671084f1",
  null
  
)

export default component.exports